export default "__VITE_ASSET__uwlzwyz9B1JDA1NXIl7hCw__"